import { gql } from "lib/apolloClient";

export const addUserActivityMutation = gql`
  mutation addUserActivity($input: AddUserActivityInput!) {
    platform {
      addUserActivity(input: $input)
    }
  }
`;

export const manualSyncAnalyticsDataMutation = gql`
  mutation ManualSyncAnalyticsData($input: ManualSyncInput!) {
    platform {
      manualSyncAnalyticsData(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;
